import * as ImplFake from './impl-fake';
import * as ImplUlcApiHub from './impl-ulc-api-hub';

/**
 * @typedef {import('./impl-ulc-api-hub').Config | import('./impl-fake').Config} Config
 */

/**
 * @type {(config: Config) => import('./interface').AddToTranscriptAPI}
 */
export const AddToTranscriptAPI = (config) => {
  switch (config.type) {
    case 'ulc-api-hub':
      return ImplUlcApiHub.AddToTranscriptAPI(config);
    case 'fake':
      return ImplFake.AddToTranscriptAPI(config);
    default:
      throw new Error(`Unknown implementation: ${config.type}`);
  }
};
